import { requestApi } from '../Api';

export const getUserDashboard = async (navigate, params) =>
  requestApi({ url: '/api/user/dashboard', navigate, params });
